import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import './admin.scss';
import {AdminComponent} from './admin';
import {AnagraficaInTdocModule} from './anagrafica-in-tdoc/anagrafica-in-tdoc.module';
import {GestioneClassiDocumentaliModule} from './gestione-classi-documentali/gestione-classi-documentali.module';
import {GestioneAnniPrecedentiModule} from './gestione-anni-precedenti/gestione-anni-precedenti.module';
import {SchedaClientiModule} from './scheda-clienti/scheda-clienti.module';
import {GestioneProfiliModule} from './gestione-profili/gestione-profili.module';
import {MarcheTemporaliModule} from './marche_temporali/marche_temporali.module';
import {UploadFatturePassiveModule} from './upload-fatture-passive/upload-fatture-passive.module';
import {GestioneRivenditoriModule} from './gestione-rivenditori/gestione-rivenditori.module';
import {AttivazioneClienteModule} from './attivazione-cliente/attivazione-cliente.module';
import {
  WorkerDownloadCsvClientiModalModule
} from './worker-download-csv-clienti-modal/worker-download-csv-clienti-modal.module';
import {ApiSecretKeyModule} from './api-secret-key/api-secret-key.module';
import {DocumentiDaConservareModule} from './documenti-da-conservare/documenti-da-conservare.module';
import {EsportazioneArchivioPretdocModule} from './esportazione-archivio-pretdoc/esportazione-archivio-pretdoc.module';
import {
  WorkerExportArchivePreTdocModalModule
} from './worker-export-archive-pre-tdoc-modal/worker-export-archive-pre-tdoc-modal.module';
import {ControlloIntegritaModule} from './controllo-integrita/controllo-integrita.module';

let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {
  $stateProvider
    .state('home.admin', {
      url: '/admin',
      ncyBreadcrumb: {
        label: 'Admin Page'
      },
      data: {
        authorisationLevel: 2,
        pageTitle: 'Admin Page'
      },
      views: {
        homeContent: {
          template: '<admin flex="100"></admin>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const AdminModule: string = ng
  .module('admin', [
    'ui.bootstrap',
    uiRouter,
    AnagraficaInTdocModule,
    GestioneClassiDocumentaliModule,
    GestioneAnniPrecedentiModule,
    SchedaClientiModule,
    GestioneProfiliModule,
    MarcheTemporaliModule,
    UploadFatturePassiveModule,
    GestioneRivenditoriModule,
    AttivazioneClienteModule,
    ApiSecretKeyModule,
    DocumentiDaConservareModule,
    WorkerDownloadCsvClientiModalModule,
    EsportazioneArchivioPretdocModule,
    WorkerExportArchivePreTdocModalModule,
    ControlloIntegritaModule
  ])
  .component('admin', AdminComponent)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/admin.module.ts